import { Controller } from "@hotwired/stimulus"

// Collapse controller - toggles visibility of target element
// Usage:
//   <button data-controller="collapse"
//           data-action="click->collapse#toggle"
//           data-collapse-target-value="my_element_id">Toggle</button>
//   <div id="my_element_id" class="hidden">Content to show/hide</div>
//
export default class extends Controller {
  static values = {
    target: String
  }

  connect() {
    // Ensure target element is hidden initially if it has the 'hidden' class
    const targetElement = document.getElementById(this.targetValue)
    if (targetElement && !targetElement.classList.contains('hidden')) {
      // Keep current state
    }
  }

  toggle(event) {
    event.preventDefault()
    const targetElement = document.getElementById(this.targetValue)

    if (!targetElement) {
      console.warn(`Collapse controller: Target element not found: ${this.targetValue}`)
      return
    }

    targetElement.classList.toggle('hidden')

    // Update button icon if present
    const icon = this.element.querySelector('i.fas')
    if (icon) {
      if (targetElement.classList.contains('hidden')) {
        icon.classList.remove('fa-chevron-up')
        icon.classList.add('fa-chevron-down')
      } else {
        icon.classList.remove('fa-chevron-down')
        icon.classList.add('fa-chevron-up')
      }
    }
  }

  show(event) {
    if (event) event.preventDefault()
    const targetElement = document.getElementById(this.targetValue)
    if (targetElement) {
      targetElement.classList.remove('hidden')
    }
  }

  hide(event) {
    if (event) event.preventDefault()
    const targetElement = document.getElementById(this.targetValue)
    if (targetElement) {
      targetElement.classList.add('hidden')
    }
  }
}
